import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	Grid,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Backdrop from '@mui/material/Backdrop';
import Typography from '@mui/material/Typography';
import Animation_Success_animation from './ServicesOperationComponent/Helper/Animation_Success_animation';

export const Alerta_Permisos_Services_Operation = ({
	open,
	CerrarModal,
	icon,
	message,
	message2,
}) => {
	const style = {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: 400,
		bgcolor: 'background.paper',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		boxShadow: 24,
		p: 4,
	};

	return (
		<>
			<Modal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				open={open}
				onClose={CerrarModal}
				closeAfterTransition
				slots={{ backdrop: Backdrop }}
				slotProps={{
					backdrop: {
						timeout: 500,
					},
				}}
			>
				<Fade in={open}>
					<Box sx={style}>
						{icon}
						<Typography id="transition-modal-description" sx={{ mt: 2, textAlign: 'center' }}>
							{message}
						</Typography>
						<Typography id="transition-modal-description2" sx={{ mt: 2 }}>
							{message2}
						</Typography>

						<Button
							type="submit"
							variant="contained"
							color="primary"
							onClick={(e) => CerrarModal(e)}
							sx={{ marginTop: '20px' }}
						>
							Volver al inicio
						</Button>
					</Box>
				</Fade>
			</Modal>
		</>
	);
};
